import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';
import { appInsights } from './telemetry'

function sendToAppInsights({ name, delta }: { name: string, delta: number, id: string }) {
    appInsights.trackMetric({ name, average: delta })
}

export function reportWebVitals() {
    onCLS(sendToAppInsights);
    onINP(sendToAppInsights);
    onLCP(sendToAppInsights);
    onFCP(sendToAppInsights);
    onTTFB(sendToAppInsights);
}

export default reportWebVitals;
